<ng-container *ngIf="isLoginLayout$ | async; else mainLayout">
	<router-outlet></router-outlet>
</ng-container>

<ng-template #mainLayout>
	<app-main-layout></app-main-layout>
</ng-template>
